<template>
  <div class="page-con">
    <div class="search-box" style="margin-bottom: 10px;">
      <span class="invoice-span">
        <label>纳税人名称:</label>
        <Select
            clearable
            v-model="clientName"
            style="width: 300px"
            filterable
            prefix="ios-arrow-down"
            :remote-method="(file) => remoteMethod(file,'clientNameOptions','api/order/','twoReport/buyerYearInvoiceSearch')"
            :default-label="[]"
            :loading="loading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) => setDefaultOptions(file, 'clientNameOptions')"
            placeholder="请选择">
          <Option v-for="option in clientNameOptions" :value="option" :key="option">{{ option }}</Option>
        </Select>
      </span>

      <span class="invoice-span">
        <label>纳税年度:</label>
        <Select
            clearable
            v-model="year"
            style="width: 100px"
            filterable
            :default-label="[]"
            :loading="loading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            placeholder="请选择">
          <Option v-for="option in yearList" :value="option" :key="option">{{ option }}</Option>
        </Select>
      </span>

      <Button
          type="primary"
          icon="ios-search"
          @click="search"
          style="margin-left: 10px"
      >查询
      </Button>

      <Button
          type="primary"
          icon="ios-add"
          v-if="isHavePermission('payment2:buyerYearInvoice:add')"
          style="margin-left: 10px"
          @click="gotoAdd"
      >创建
      </Button>

      <Button icon="md-download" @click="download" style="margin-left: 10px"
              v-if="isHavePermission('payment2:buyerYearInvoice:download')"
      >导出
      </Button>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
          ref="xTable"
          stripe
          class="table-style"
          align="center"
          highlight-hover-row
          border="none"
          :loading="loading"
          show-footer
          :data="invoiceListData"
          :footer-method="footerMethod"
          resizable
      >
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.index }}</span>
            <Dropdown trigger="click" style="margin-left: 20px" transfer
                      v-if="isHavePermission('payment2:buyerYearInvoice:setInitYear')">
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" @click="gotoSetInitYear(row)"
                  >各年度期初余额
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="replaceTaxpayer" title="纳税人名称" show-overflow></vxe-table-column>
        <vxe-table-column field="repalceTaxNum" title="纳税人证件号码" show-overflow></vxe-table-column>
        <vxe-table-column field="year" title="纳税年度" show-overflow></vxe-table-column>
        <vxe-table-column field="initAmount" title="年度期初开票" show-overflow></vxe-table-column>
        <vxe-table-column field="systemAmount" title="系统年度开票" show-overflow></vxe-table-column>
        <vxe-table-column field="totalAmount" title="年度累计开票" show-overflow></vxe-table-column>
        <vxe-table-column field="leftAmount" title="年度剩余额度" show-overflow></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="change"
      ></vxe-pager>
    </div>

    <AddBuyerYearInvoice ref="addBuyerYearInvoice" @success="getList"></AddBuyerYearInvoice>

    <SetInitBuyerYearInvoice ref="setInitBuyerYearInvoice" @success="getList"></SetInitBuyerYearInvoice>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {numberToCurrency} from "@/filters/type";
import {getBlob, hideLoading, isEmpty, isNotEmpty, saveBlob, showLoading} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";
import {apiPost} from "@/utils/api";
import AddBuyerYearInvoice from "@/components/payment2/AddBuyerYearInvoice";
import SetInitBuyerYearInvoice from "@/components/payment2/SetInitBuyerYearInvoice";

export default {
  mixins: [getAuthOrization],
  components: {AddBuyerYearInvoice, SetInitBuyerYearInvoice},
  data() {
    return {
      loading: false,
      clientName: '',
      year: null,
      invoiceListData: [],
      isDesc: null,
      orderBy: null,
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      countRtnVo: {
        totalAmount: null,
        leftAmount: null,
        systemAmount: null,
        initAmount: null,
      },
      param: {},
      clientNameOptions: [],
      yearList: []
    }
  },
  mounted() {
    this.$bus.$on("代开发票统计", () => {
      this.clientName = '';
      this.getList();
    });
    this.getList();
    this.getListData('', 'clientNameOptions', 'api/order/', 'twoReport/buyerYearInvoiceSearch');
  },
  methods: {
    gotoAdd() {
      this.$refs.addBuyerYearInvoice.show()
    },
    gotoSetInitYear(row) {
      this.$refs.setInitBuyerYearInvoice.show(row)
    },
    change(val) {
      this.page.currentPage = val.currentPage;
      this.page.pageSize = val.pageSize;
      this.getList();
    },
    search() {
      this.page.currentPage = 1
      this.getList();
    },
    footerMethod({columns, data}) {
      // 底部合计
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "全部合计";
          }
          if (["initAmount"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.initAmount);
          }
          if (["leftAmount"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.leftAmount);
          }
          if (["systemAmount"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.systemAmount);
          }
          if (["totalAmount"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.totalAmount);
          }
          return null;
        }),
      ];
    },
    async getList() {
      this.loading = true
      let param = {
        orderBy: this.orderBy,
        isDesc: this.isDesc,
        page: this.page.currentPage,
        rows: this.page.pageSize
      }
      if (isNotEmpty(this.clientName)) {
        param.clientName = this.clientName
      }
      if (isNotEmpty(this.year)) {
        param.year = this.year
      }
      this.param = param;
      let res = await $api.twoReport.post("countClientBuyerYearInvoice", param)
      this.loading = false
      if (res.status === 1) {
        res.data.rows.forEach(item => {
          item.index = (this.page.currentPage - 1) * 10 + 1 + res.data.rows.indexOf(item)
        })
        this.invoiceListData = res.data.rows
        this.page.totalResult = res.data.total;
        this.countRtnVo = isEmpty(res.data.countRtnVo) ? {} : res.data.countRtnVo;
      }
    },
    async download() {
      showLoading();
      let res = getBlob("/api/order/twoReport/exportClientBuyerYearInvoice", this.param);
      hideLoading();
      await saveBlob(".zip", res.data);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path) {
      if (query !== "") {
        this.getListData(query, options, url, path);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getListData(query, options, url, path) {
      let params = {};
      if (!isEmpty(query)) {
        params.word = query;
      }
      let res = await apiPost(url, path, params);
      if (res.status === 1) {
        this[options] =   res.data.clientNameList.filter(o => isNotEmpty(o))
        this.yearList =   res.data.yearList.filter(o => isNotEmpty(o))
      }
    },
  }
}

</script>


<style scoped>

.search-box .invoice-span {
  display: inline-block;
  padding-right: 10px;
  margin-bottom: 10px;
}

.finance-span-time .line-icon {
  display: inline-block;
  width: 52px;
  text-align: center;
}

.search-box label {
  display: inline-block;
  padding: 0 5px;
  color: #999;
}

.search-box .vxe-input--inner,
.search-box .ivu-input,
.search-box .ivu-select-selection {
  border-radius: 0;
  border: 1px solid #dcdee2;
  height: 34px;
  box-sizing: border-box;
}

.search-box .ivu-select {
  width: 320px;
  height: 34px;
  overflow: hidden;
}

.search-box .ivu-select-multiple .ivu-tag,
.search-box .ivu-select-input {
  display: inline-block;
  float: left;
}

.search-box .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  max-height: 32px;
  border-radius: 0;
}

.search-box .ivu-select-prefix i {
  vertical-align: middle;
  position: absolute;
  right: 8px;
  top: 8px;
}

</style>